/** #463, PO 24.10.2026: „unsere Aufgabe ist ja die Uhrzeiten zu ermitteln aus den Chats“.
 * One booking fact for all readers; legacy values are read only during the transition.
 * ISO asOf keeps provenance identical through Firestore, tasks and the dashboard API.
 */
export interface AgreedTime {
  time: string;
  quote: string;
  sourceChannel: string;
  asOf: string;
  status: 'requested' | 'confirmed';
  /** Operational approval from the ledger (including automatic approval), separate from a quoted promise. */
  approved?: boolean;
  /** #747: newest active wish without an open decision, ordered by createdAt as on main.
   * null means evidence exists but no wish may affect the plan; absent = older projection. */
  planTime?: string | null;
}
/** #522, PO 29.10.2026: „Das Modell liest Datum und Uhrzeit aus der Gastnachricht mit und fragt nur im Zweifel beim Gast nach.“ */
export interface ArrivalAssessment {
  date: string | null;
  /** Verbatim guest words supporting the date or its ambiguity. */
  quote: string;
  needsClarification: boolean;
}
export interface AgreedTimes {
  checkIn?: AgreedTime;
  checkOut?: AgreedTime;
  /** #522: model-read arrival date of the newest live check-in wish, independent of a known clock time. */
  arrival?: ArrivalAssessment | null;
}
export function bookingTime(times: AgreedTimes | undefined, field: 'checkIn' | 'checkOut', fallback?: string | null): string | undefined {
  // #747: a checkout fact or a bed-only projection must not hide the PMS arrival (and vice versa).
  return times?.[field]?.time ?? fallback ?? undefined;
}
